import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.hanscribe.precheck');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-hanscribe-precheck',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.hanscribe.precheck/view.scss */
:host {
  display: block;
  min-height: 100vh;
}`],
})
export class PageHanscribePrecheckComponent implements OnInit {
    public encounterId = '';
    public sourceChannel = 'operator';
    public precheckToken = '';
    public precheckContext: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.encounterId = this.pathEncounterId();
        this.precheckToken = this.queryValue('token');
        this.sourceChannel = this.resolveSourceChannel();
        this.precheckContext = {
            encounter_id: this.encounterId,
            source_channel: this.sourceChannel,
            entry_mode: this.sourceChannel === 'patient' ? 'patient' : 'operator',
            precheck_token: this.precheckToken,
        };
        this.removeSensitiveTokenFromUrl();
        await this.service.render();
    }

    private resolveSourceChannel() {
        if (this.precheckToken) return 'patient';
        const explicit = this.queryValue('source_channel');
        if (explicit === 'patient') return 'patient';
        if (explicit === 'operator') return 'operator';

        const role = this.service.auth.session?.role || '';
        if (role === 'doctor') return 'doctor';
        if (role === 'admin') return 'admin';
        return 'operator';
    }

    private queryValue(key: string) {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return params.get(key) || '';
        } catch (e) {
            return '';
        }
    }

    private pathEncounterId() {
        try {
            const parts = (window.location.pathname || '').split('/').filter((part) => !!part);
            const index = parts.indexOf('precheck');
            if (index >= 0 && parts[index + 1]) return decodeURIComponent(parts[index + 1]);
            return '';
        } catch (e) {
            return '';
        }
    }

    private removeSensitiveTokenFromUrl() {
        if (!this.precheckToken) return;
        try {
            const url = new URL(window.location.href);
            url.searchParams.delete('token');
            window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
        } catch (e) {
            // Older embedded browsers may not expose history replacement.
        }
    }
}

export default PageHanscribePrecheckComponent;